import { useParams } from 'react-router-dom';
import { blogPosts } from '../../mocks/blogPosts';
import Navbar from './components/Navbar';
import BlogPostHero from './components/BlogPostHero';
import BlogPostContent from './components/BlogPostContent';
import BlogPostSidebar from './components/BlogPostSidebar';
import SocialShare from './components/SocialShare';
import RelatedPosts from './components/RelatedPosts';
import BlogPostCTA from './components/BlogPostCTA';
import Footer from '../home/components/Footer';

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find(p => p.slug === slug);

  if (!post) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Post Not Found</h1>
          <p className="text-gray-600">The blog post you're looking for doesn't exist.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <BlogPostHero />
      
      {/* Main Content */}
      <div className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-7xl mx-auto">
            <div className="grid lg:grid-cols-3 gap-12">
              {/* Article Content */}
              <div className="lg:col-span-2">
                <BlogPostContent />
                <SocialShare />
              </div>
              
              {/* Sidebar */}
              <div className="lg:col-span-1">
                <div className="sticky top-8">
                  <BlogPostSidebar />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Related Posts */}
      <RelatedPosts />
      
      {/* CTA Banner */}
      <BlogPostCTA />
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default BlogPost;